import { useLayoutEffect } from 'react'

import { noop } from '@lib/helpers/client'

const useIsomorphicEffect = typeof window !== 'undefined' ? useLayoutEffect : noop

export default useIsomorphicEffect
